var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{style:({ cursor: _vm.SettingWorkDocsWorkAreaPage ? 'pointer' : null }),on:{"click":function($event){_vm.SettingWorkDocsWorkAreaPage
      ? _vm.$router.push({ name: 'SettingWorkDocsWorkAreaProject', params: { id: _vm.item.id } })
      : ''}}},[_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),(!_vm.SettingWorkDocsWorkAreaPage)?_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_work_areas',
        })
      )?_c('div',{staticClass:"buttons"},[_c('WorkDocsWorkAreaModal',{attrs:{"create":false,"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"text":_vm.localStorage.translations.pages['setting-work_area']['dialog_delete'][
            'udalit-zonu-rabot'
          ] +
          ' ' +
          _vm.item.name}})],1):_vm._e()]):(_vm.$vuetify.breakpoint.mdAndUp)?_c('td'):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }